import { useTranslation } from "@opendash/i18n";
import { Card, Statistic } from "antd";
import { observer } from "mobx-react-lite";
import Parse, { User } from "parse";
import React, { useEffect, useState } from "react";
import { Ticket } from "../../../../../js/parsegenerated";

export const AssignedToMe = observer(() => {
  const t = useTranslation();
  const [assignedTickets, setAssignedTickets] = useState(0);

  useEffect(() => {
    new Parse.Query(Ticket)
      .matchesQuery(
        "assignedusers",
        new Parse.Query(User).equalTo("objectId", Parse.User.current().id)
      )
      .count()
      .then((count) => {
        setAssignedTickets(count);
      });
  }, []);

  return (
    //@ts-ignore
    <Card variant="outlined" style={{ width: "100%" }}>
      <Statistic
        title={t("maintenance:overview.statistics.assigendtome.title")}
        value={assignedTickets}
      />
    </Card>
  );
});
